const { Product, ProductType } = require('@/models');

const { baseTimeFields, createdTimeField } = require('@/classes/timeFields');

module.exports = {
    tabs: [
        {
            path: 'products',
            text: 'Assets',
            counter: (eod) => {
                return eod.count('countTreeObjects', {
                    where: [
                        {
                            column: 'class',
                            value: 'DEVICE'
                        }
                    ]
                }).then(response => {
                    if (response.data.data && response.data.data.countTreeObjects) {
                        return response.data.data.countTreeObjects.totalCount;
                    } else {
                        return 0;
                    }
                });
            }
        },
        {
            path: 'products.types',
            text: 'Types',
        }
    ],
    routes: [
        {
            path: '/devices',
            name: 'products',
            meta: {
                permissions: ['products.devices.read']
            },
            component: () => import('./views/index.vue')
        },
        {
            path: '/devices/settings',
            name: 'products.settings',
            component: () => import('./views/settings.vue')
        },
        {
            path: '/devices/types',
            name: 'products.types',
            meta: {
                permissions: ['products.devices.read']
            },
            component: () => import('./types/index.vue')
        },
        {
            path: '/devices/types/detail/:id?',
            name: 'products.type',
            component: () => import('./types/detail.vue')
        },
        {
            path: '/devices/types/settings',
            name: 'products.types.settings',
            component: () => import('./types/settings.vue')
        },
    ],
    search: Product.searchConfig,
    detail: {
        route: 'product',
        endpoint: 'product',
        objectName: 'Product',
    },
    index: {
        route: 'products',
        endpoint: 'products',
        filterName: 'assetsOverview',
        settingsRoute: 'products.settings',
        fields: ['id', 'name', 'statusCode{id name}', 'description', 'class', 'productType{id name}', 'createdAt', 'updatedAt'],
        headers: [
            {
                text: 'Naam',
                value: 'name',
                component: () => import('@/components/columns/eod-column-link.vue')
            },
            {
                text: 'Type',
                value: 'productType.name',
                sortable: false,
                component: () => import('@/components/columns/eod-column-link.vue')
            },
            {
                text: 'Status',
                value: 'statusCode.name',
                sortable: false,
                component: () => import('@/components/columns/eod-column-link.vue')
            },
            {
                text: 'Aanmaakdatum',
                width: 50,
                value: 'createdAt',
                component: () => import('@/components/columns/eod-column-date.vue'),
                extra: {
                    icon: 'mdi-alarm-plus',
                    collapsed: true,
                    prepend: 'Aangemaakt op'
                }
            }, {
                text: 'Aanpassingsdatum',
                width: 50,
                value: 'updatedAt',
                component: () => import('@/components/columns/eod-column-date.vue'),
                extra: {
                    icon: 'mdi-alarm',
                    collapsed: true,
                    prepend: 'Gewijzigd op'
                }
            },
            {
                width: 120,
                sortable: false,
                value: 'actions',
                draggable: false,
                component: () => import('@/components/columns/eod-column-actions.vue')
            }
        ],
        tabs: [],
    },
    export: {
        endpoint: 'products',
        fields: ['id', 'name', 'description', 'code', 'warrantyEndDate', 'installedDate', 'lastMaintenanceDate', 'createdAt', 'updatedAt']
    },
    import: {
        endpoint: 'Products',
        objectName: 'Product',
    },
    itemObject: Product,
    types: {
        search: ProductType.searchConfig,
        itemObject: ProductType,
        defaultTimeField: 'createdAt',
        timeFields: baseTimeFields,
        index: {
            route: 'products.types',
            endpoint: 'productTypes',
            settingsRoute: 'products.types.settings',
            fields: ['id', 'name', 'code', 'supplierCode', 'isActive', 'suppliers{id name}', 'manufacturers{id name}', 'icon', 'type', 'class'],
            headers: [
                {
                    text: 'Icoon',
                    value: 'icon',
                    width: 30,
                    component: () => import('@/components/columns/eod-column-icon.vue')
                },
                {
                    text: 'Naam',
                    value: 'name',
                    component: () => import('@/components/columns/eod-column-link.vue')
                },
                {
                    text: 'Type',
                    value: 'type',
                    width: 250,
                    component: () => import('@/components/columns/eod-column-link.vue')
                },
                {
                    text: 'Modelnummer',
                    value: 'code',
                    width: 250,
                    component: () => import('@/components/columns/eod-column-link.vue')
                },
                {
                    text: 'Artikelnummer',
                    value: 'supplierCode',
                    width: 250,
                    component: () => import('@/components/columns/eod-column-link.vue')
                },
                {
                    text: 'Leveranciers',
                    value: 'suppliers',
                    sortable: false,
                    width: 250,
                    component: () => import('@/components/columns/eod-column-tags.vue')
                },
                {
                    text: 'Fabrikanten',
                    value: 'manufacturers',
                    sortable: false,
                    width: 250,
                    component: () => import('@/components/columns/eod-column-tags.vue')
                },
                {
                    text: '',
                    value: 'isActive',
                    draggable: false,
                    sortable: false,
                    extra: {
                        checkRelated: true
                    },
                    component: () => import('@/components/columns/eod-column-toggle.vue')
                },
                {
                    text: 'Aanmaakdatum',
                    width: 50,
                    value: 'createdAt',
                    component: () => import('@/components/columns/eod-column-date.vue'),
                    extra: {
                        icon: 'mdi-alarm-plus',
                        collapsed: true,
                        prepend: 'Aangemaakt op'
                    }
                }, {
                    text: 'Aanpassingsdatum',
                    width: 50,
                    value: 'updatedAt',
                    component: () => import('@/components/columns/eod-column-date.vue'),
                    extra: {
                        icon: 'mdi-alarm',
                        collapsed: true,
                        prepend: 'Gewijzigd op'
                    }
                }, {
                    width: 120,
                    sortable: false,
                    value: 'actions',
                    draggable: false,
                    component: () => import('@/components/columns/eod-column-actions.vue')
                }
            ],
        },
        detail: {
            route: 'products.type',
            endpoint: 'productType',
            objectName: 'ProductType',
            fields: ['id', 'name', 'class', 'icon', 'taskTypeConfig{id taskType{id} jobType{id} variant}', 'code', 'supplierCode', 'customFields{customFieldId, module, itemId, value}', 'description', 'unit{id}', 'url', 'type', 'suppliers{id name}', 'manufacturers{id name}', 'measurementTypes{id name settings{starttime endtime value} unit{id name}}'],
            tabs: []
        },
        export: {
            endpoint: 'productTypes',
            fields: ['id', 'name', 'description', 'vendor', 'type', 'url']
        },
        import: {
            endpoint: 'ProductTypes',
            objectName: 'ProductType',
        },
    }
}